import { useLocation, useNavigate } from "react-router-dom";
import horemowicon from "../otherImg/hbrlitenewicon.png"
import { Hbrbackarrow } from "../newComponents/Mycustomsvgicons";



const Donation = () => {
    const navigate = useNavigate();
    const location = useLocation();
  
    const closePage=()=>{
      if (location.state && location.state.from) {
          navigate(location.state.from);
      }else{
          navigate("/");
      }
    };

    return ( 
        <div className="donationPage">
            <div className="flex-row2" style={{width:"100%", gap:"30px"}}>
            <Hbrbackarrow width={"2em"} height={"2em"} fillColour={"black"} handleClick={()=>closePage()}/>
            <h3>Donation</h3>
          </div>
          
         <img src={horemowicon} alt="Official App Logo" />

           <p>The Horemow Book Reader website is a free website developed to equip end time christians with the Gospel truth. 
            The books and other resources on the sites are hosted on servers and real time databases. Aside the website,
            we also have a build for native android devices. We are planning to expand the build to more operating systems.
            More financial support is needed to fund the project. 
            Find attached below the bank details and other ways to donate to this cause.<br/><br/>

           <em>Use the link to Donate directly to the Project Account.</em> <br/> <br/>
            <a href="https://paystack.com/pay/hbr" style={{
                color: "blue",
                fontSize: "20",
            }}>Use Paystack transfer</a> <br/><br/>

            <em>You can also manually use the following Bank Details to remit your Donation</em> <br/> <br/>
            Bank Name: United Bank for Africa Ghana Limited <br/> <br/>
            Account Number: 02906377602500 <br/> <br/>
            Swift Code: STBGGHACXXX <br/> <br/>
            Account Name: Ransford Addotei Pappoe <br/><br/>

            <em>CAL BANK LTD SWIFT TRANSFER DETAILS</em> <br/>
            USD <br/><br/>
            BANK NAME AND ADDRESS:
            CITIBANK N. A,
            399 PARK AVENUE,
            NEWYORK CITY, 
            NY 10043. <br/> <br/>

            SWIFT CODE 			 	-   CITIUS33  <br/> <br/>
            ROUTING NO.				-   021000089 <br/> <br/>
            ACCOUNT NAME:		  	- CAL BANK LTD <br/> <br/>
            CAL SWIFT CODE:	        -      ACCCGHAC <br/> <br/>
            CAL's ACCOUNT NUMBER	-   36209949 <br/> <br/>
            BENEFICIARY             - 1400003250034 <br/><br/>
           </p> <br/><br/>

        </div>
     );
}
 
export default Donation;